(function () {
  'use strict';

  const WRAPPER_ATTR = 'data-nicha-description-accordion';
  const DETAILS_ID = 'Details-nicha-product-description';
  const CONTENT_ID = 'ProductAccordion-nicha-product-description';

  const isProductPage = () =>
    document.body.classList.contains('template-product') ||
    document.body.classList.contains('nicha-product-page') ||
    !!document.querySelector('.product__info-container, .product__info-wrapper');

  const isEnglish = () => {
    const locale = (window.Shopify?.locale || document.documentElement.lang || 'fr').toLowerCase();
    return locale === 'en' || locale.startsWith('en-');
  };

  const getDetailsTitle = () => (isEnglish() ? 'Details' : 'Détails');

  const findDescription = () => {
    const candidates = [
      ...document.querySelectorAll(
        '.product__info-container > .product__description, .product__info-wrapper > .product__description, .product__info-container .product__description.rte, .product__info-wrapper .product__description.rte'
      ),
    ];

    return (
      candidates.find((el) => {
        if (!el || el.closest('.product__accordion')) return false;
        if (el.dataset.nichaDescriptionMoved === 'true') return false;
        const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        return text.length > 0;
      }) || null
    );
  };

  const buildAccordion = (templateDetails, description) => {
    const wrapper = document.createElement('div');
    wrapper.className = 'product__accordion accordion';
    wrapper.setAttribute(WRAPPER_ATTR, 'true');

    const details = document.createElement('details');
    details.id = DETAILS_ID;

    const summary = templateDetails.querySelector('summary')?.cloneNode(true);
    if (!summary) return null;

    summary.setAttribute('aria-controls', CONTENT_ID);
    summary.setAttribute('aria-expanded', 'false');

    const titleEl = summary.querySelector('.accordion__title');
    if (titleEl) titleEl.textContent = getDetailsTitle();

    const content = document.createElement('div');
    content.className = 'accordion__content rte';
    content.id = CONTENT_ID;

    while (description.firstChild) {
      content.appendChild(description.firstChild);
    }

    details.appendChild(summary);
    details.appendChild(content);
    wrapper.appendChild(details);

    return wrapper;
  };

  const moveDescriptionIntoAccordion = () => {
    if (!isProductPage()) return false;
    if (document.querySelector(`[${WRAPPER_ATTR}]`)) return true;

    const description = findDescription();
    if (!description) return false;

    const firstAccordion = document.querySelector('.product__accordion');
    const templateDetails = firstAccordion?.querySelector('details');
    if (!templateDetails) return false;

    const wrapper = buildAccordion(templateDetails, description);
    if (!wrapper) return false;

    firstAccordion.parentNode.insertBefore(wrapper, firstAccordion);
    description.remove();

    return true;
  };

  const boot = () => {
    if (!isProductPage()) return;

    moveDescriptionIntoAccordion();
    [200, 600, 1200, 2500].forEach((delay) => {
      setTimeout(moveDescriptionIntoAccordion, delay);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', () => {
    setTimeout(moveDescriptionIntoAccordion, 100);
  });

  window.NichaProductDescriptionAccordion = {
    refresh: moveDescriptionIntoAccordion,
  };
})();
